import { gql } from "@apollo/client";

export const ADVOCATE_REFERRAL_STATUS = gql`
    query GetAdvocateReferredStatus {
        getAdvocateReferredStatus {
            hasReferredFriend
            messages
            success
        }
    }
`;
